"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionsToTypes = exports.sortOptions = exports.calculateNewOption = exports.typesToOptions = exports.toOption = exports.getOptionLabel = void 0;
var sortBy_1 = __importDefault(require("lodash/sortBy"));
function getOptionLabel(_a, renderLineOfCoverageType) {
    var type = _a.type, index = _a.index;
    var typeReadableName = renderLineOfCoverageType(type);
    if (index === 0)
        return typeReadableName;
    return typeReadableName + " " + (index + 1);
}
exports.getOptionLabel = getOptionLabel;
function toOption(type, index) {
    return {
        id: type + "_" + index,
        type: type,
        index: index,
    };
}
exports.toOption = toOption;
/**
 * Get LineOfCoverageTypeOption array with the options from an array of LineOfCoverageType
 * which can include repetitions
 * @param types
 */
function typesToOptions(types) {
    var indexesPerType = {};
    return sortOptions(types.map(function (type) {
        var index = indexesPerType[type] || 0;
        indexesPerType[type] = index + 1;
        return toOption(type, index);
    }));
}
exports.typesToOptions = typesToOptions;
/**
 * Calculates which would be the new option if a LineOfCoverageType needs to be added to the current options.
 * @param currentOptions
 * @param type
 */
function calculateNewOption(currentOptions, type) {
    var index = currentOptions.filter(function (option) { return option.type === type; }).length;
    return toOption(type, index);
}
exports.calculateNewOption = calculateNewOption;
function sortOptions(options) {
    return sortBy_1.default(options, function (option) { return getOptionLabel(option, function (type) { return type; }); });
}
exports.sortOptions = sortOptions;
function optionsToTypes(options) {
    return options.map(function (_a) {
        var type = _a.type;
        return type;
    });
}
exports.optionsToTypes = optionsToTypes;
